import React, { useState } from "react";
import WindowChrome from "./WindowChrome.jsx";

export const HERO_YOUTUBE_ID = "dYvjhIAzByo";
export const HERO_YOUTUBE_THUMBNAIL = `https://img.youtube.com/vi/${HERO_YOUTUBE_ID}/maxresdefault.jpg`;

const PlayIcon = () => (
  <span className="cursor-video-play-icon">
    <svg
      className="cursor-play-icon"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M8 5v14l11-7z" />
    </svg>
  </span>
);

const QuietVideoPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => setIsPlaying(true);

  return (
    <div className="cursor-video-wrap" data-testid="quiet-video">
      <div className="cursor-video-window">
        <WindowChrome title="FractoLabs Demo" />
        <div className="cursor-video-body">
          {isPlaying ? (
            <iframe
              src={`https://www.youtube.com/embed/${HERO_YOUTUBE_ID}?autoplay=1&rel=0&modestbranding=1`}
              title="FractoLabs 60-second product demo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              data-testid="quiet-video-youtube"
            />
          ) : (
            <>
              <img
                src={HERO_YOUTUBE_THUMBNAIL}
                alt=""
                className="cursor-video-thumbnail"
                loading="eager"
              />
              <button
                type="button"
                className="cursor-video-play"
                onClick={handlePlay}
                aria-label="Play 60-second demo video"
                data-testid="quiet-video-play"
              >
                <PlayIcon />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuietVideoPlayer;
